export const buildResponse = (response: any) => {
  if (response?.error) {
    return { success: false, error: response?.error, data: null };
  }
  return { success: true, data: response.data?.result, error: null };
};
